import styles from "./style.module.scss";

export const TextSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <p>
          株式会社あいホーム（以下「当社」）は、当社が運営する石巻マリンヴィレッジ（以下「当施設」）におけるお客様の個人情報の取り扱いについて、以下のとおり個人情報保護方針（以下「本方針」）を定めます。
          <br />
          <br />
          個人情報保護に関する基本方針
          <br />
          当社は、個人情報保護法をはじめとする関連法規を遵守し、お客様の個人情報を適切に保護することを重要な責務と考えております。当社は、お客様に安心して石巻マリンヴィレッジをご利用いただくために、本方針に基づき、個人情報の取得、利用、管理を適切に行います。
          <br />
          <br />
          個人情報の利用目的
          <br />
          当社は、お客様から取得した個人情報を以下の目的で利用します。
          <br />
          <br />
          ・宿泊予約の受付、確認、案内および管理
          <br />
          ・宿泊サービスの提供
          <br />
          ・お問い合わせへの対応
          <br />
          ・緊急時の連絡
          <br />
          ・キャンセル時の手続き
          <br />
          ・宿泊時サービス向上のためのアンケート調査
          <br />
          ・法令に基づく宿泊者名簿の作成
          <br />
          ・体験提供事業者への情報共有
          <br />
          ・ご希望されるお客様へのご案内の送付
          <br />
          ・その他、宿泊施設運営に必要な業務
          <br />
          <br />
          個人情報の取得方法
          <br />
          当社は、以下の方法によりお客様の個人情報を取得いたします。
          <br />
          ・当サイトの予約フォーム
          <br />
          ・当施設チェックイン時の宿泊者名簿への記入
          <br />
          ・当サイトのお問い合わせフォーム
          <br />
          <br />
          個人情報の提供について
          <br />
          ご提供いただいた個人情報は、下記を除き第三者への提供は致しません。
          <br />
          ・お客様の同意を頂いた場合
          <br />
          ・法令に基づく場合
          <br />
          ・人の生命･健康･財産･安全などを保護／防御するために必要な場合
          <br />
          ・公的機関より法律に基づく権限による開示請求があった場合
          <br />
          ・適切な保護処理を講じた上で、個人情報のデータ処理やコンピュータシステムの保守管理等に必要な業務委託をする場合
          <br />
          <br />
          個人情報の開示・訂正・利用停止等の手続き
          <br />
          当社は、お客様ご本人から、個人データの開示、訂正、追加、削除、利用停止、消去、第三者提供の停止等のご請求があった場合、法令に基づき適切に対応いたします。ご請求の方法、必要な書類、受付窓口、対応期間等については、こちらのお問い合わせフォームにご連絡いただいた方に別途ご案内いたします。
          <br />
          <br />
          お問い合わせ窓口
          <br />
          個人情報の取り扱いに関するお問い合わせはこちらまでご連絡ください。
          <br />
          <br />
          制定日：2025年4月9日
          <br />
          株式会社あいホーム
        </p>
      </div>
    </section>
  );
};
